export default __webpack_public_path__ + "static/media/person-three-circles.714ad4bb.svg";